<script>
import galleryData from "../assets/data.json";

import Gallery360 from "./360.vue";

export default {
  name: "gallery",

  components: {
    Gallery360
  },

  computed: {
    items() {
      return galleryData.items;
    },
  },
};
</script>

<template>
  <div class="container">
    <div class="row">
      <div class="col-12 gallery">
        <template v-for="(item, idx) in items">
          <div
            :key="`name-${item.id}`"
            :id="`photo-${item.id}`"
            class="name display-4 accent my-3 mb-md-5"
          >
            <span v-html="item.name" />,
            <span class="small">{{ item.suffix }}</span>
          </div>

          <img
            :key="`mobile-photo-${item.id}`"
            @contextmenu.prevent="() => {return false}"
            class="photo img-fluid"
            :src="item.photo"
          />

          <div
            :key="`desktop-photo-${item.id}`"
            @contextmenu.prevent="() => {return false}"
            @click="$emit('show:item', item)"
            class="bg-photo"
            :style="{
              backgroundImage: `url(${item.thumbnail})`,
              backgroundPosition: item.thumbnailPosition,
              gridArea: `photo-${idx + 1}`,
            }"
          ></div>

          <div :key="`text-${item.id}`" class="text pt-3 pb-5">
            <audio
              v-if="item.audioFile"
              @play="$emit('audio:playing')"
              @ended="$emit('audio:stopped')"
              class="item-player"
              controls
              ref="itemplayer"
            >
              <source :src="item.audioFile" />
            </audio>

            <div v-html="item.text" />
          </div>

          <div
            :key="`callout-${item.id}`"
            @click="$emit('show:item', item)"
            class="callout"
            :class="item.calloutClass"
            :style="{
              gridArea: `callout-${idx + 1}`,
            }"
          >
            <div>&ldquo;<span v-html="item.pullQuote" />&rdquo;</div>
          </div>
        </template>
      </div>
      <div class="col-12 mt-5">
        <h2 class="accent">360&deg; tour</h2>
        <p class="d-none d-md-block">Click and drag the 360&deg; tour below to experience the exhibit as it was originally presented.</p>
        <p class="d-md-none">Tap and drag the 360&deg; tour below to experience the exhibit as it was originally presented.</p>
        <Gallery360
          @show:itemid="
            $emit(
              'show:item',
              items.find((item) => item.id === $event)
            )
          "
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.gallery {
  display: flex;
  flex-direction: column;

  .bg-photo,
  .callout {
    display: none;
  }
}

/** SM breakpoint */
@media screen and (min-width: 576px) and (max-width: 767px) {
}

/** MD breakpoint */
@media screen and (min-width: 768px) and (max-width: 991px) {
  .bg-photo, .callout {
    min-height: 222px;
  }
}

/** LG breakpoint */
@media screen and (min-width: 992px) and (max-width: 1199px) {
  .bg-photo, .callout {
    min-height: 302px;
  }
}

/** XL breakpoint */
@media screen and (min-width: 1200px) and (max-width: 1399px) {
  .bg-photo, .callout {
    min-height: 362px;
  }
}

/** XXL breakpoint */
@media screen and (min-width: 1400px) {
  .bg-photo, .callout {
    min-height: 422px;
  }
}

@media screen and (min-width: 768px) {
  .gallery {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, 1fr);
    column-gap: 15px;
    row-gap: 15px;
    grid-template-areas: 
      "callout-1 callout-1 photo-1"
      "callout-2 photo-2 photo-1"
      "photo-3 photo-3 callout-3"
      "callout-4 callout-4 photo-4"
      "callout-5 photo-5 photo-4"
      "photo-6 callout-6 callout-6"
      "photo-7 photo-7 callout-7"

      "photo-8 callout-8 callout-8"
      "photo-8 photo-9 callout-9"
      "callout-10 photo-10 photo-10"
      "photo-11 callout-11 callout-11"
      "photo-11 photo-12 callout-12"
      "callout-13 callout-13 photo-13"
      "callout-14 photo-14 photo-14"

      "callout-15 callout-15 photo-15"
      "callout-16 photo-16 photo-15"
      "photo-17 photo-17 callout-17"
      "callout-18 callout-18 photo-18"
      "callout-19 photo-19 photo-18"
      "photo-20 callout-20 callout-20"
      "photo-21 photo-21 callout-21"
      ;

    .item-player,
    .name,
    .photo,
    .text {
      display: none !important;
    }

    .bg-photo {
      display: block !important;
      background-size: cover;
      background-repeat: no-repeat;
      height: 100% !important;
      width: 100% !important;
      cursor: pointer;
    }

    .callout {
      display: flex;
      align-self: center;
      flex-direction: column;
      justify-content: center;
      cursor: pointer;
    }
  }
}
</style>